export default __webpack_public_path__ + "static/media/deleteIcon2.915246cc.svg";